"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationApi = exports.ReservationApiFactory = exports.ReservationApiFp = exports.ReservationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ReservationApi - axios parameter creator
 * @export
 */
const ReservationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get previously reserved scheme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeDeliveryEndpointGetScheme: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/schemedelivery/reserved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ReservationApiAxiosParamCreator = ReservationApiAxiosParamCreator;
/**
 * ReservationApi - functional programming interface
 * @export
 */
const ReservationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ReservationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get previously reserved scheme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeDeliveryEndpointGetScheme(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeDeliveryEndpointGetScheme(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReservationApi.schemeDeliveryEndpointGetScheme']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ReservationApiFp = ReservationApiFp;
/**
 * ReservationApi - factory interface
 * @export
 */
const ReservationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ReservationApiFp)(configuration);
    return {
        /**
         * Get previously reserved scheme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeDeliveryEndpointGetScheme(options) {
            return localVarFp.schemeDeliveryEndpointGetScheme(options).then((request) => request(axios, basePath));
        },
    };
};
exports.ReservationApiFactory = ReservationApiFactory;
/**
 * ReservationApi - object-oriented interface
 * @export
 * @class ReservationApi
 * @extends {BaseAPI}
 */
class ReservationApi extends base_1.BaseAPI {
    /**
     * Get previously reserved scheme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    schemeDeliveryEndpointGetScheme(options) {
        return (0, exports.ReservationApiFp)(this.configuration).schemeDeliveryEndpointGetScheme(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ReservationApi = ReservationApi;
//# sourceMappingURL=reservation-api.js.map